import { useUser } from '@/domains/auth'
import { useSetupState } from '@/domains/setup'

import type { NotificationRecipient } from './renderers'

/** resolves the current user to the recipient shape consumed by
 * renderer.link(payload, recipient). super-style links (e.g. due-diligence)
 * only apply while acting as the system company. a super acting as a regular
 * company gets owner-style links, matching the rest of the super-context
 * gating.
 */
export function useNotificationRecipient(): NotificationRecipient {
  const { user } = useUser()
  const { setupState } = useSetupState()
  const isSuper = (user?.isSuper ?? false) && setupState?.scope === 'super'
  return { isSuper }
}
